import type { ActionTree } from 'vuex';
import { translate } from '@lib-shared/helpers/translation.helper';
import { ETwilioAction, ETwilioMutation } from './twilio.constants';
import type { ITwilioState } from '@signing-page/integrations/twilio/store/twilio.types';
import type { IRootState } from '@signing-page/store/store';
import TwilioService from '@signing-page/integrations/services/twilio.service';

export const actions: ActionTree<ITwilioState, IRootState> = {
  async [ETwilioAction.CallPhone]({ rootState, commit, dispatch }, phoneNumber: string) {
    commit(ETwilioMutation.SetError, null);
    commit(ETwilioMutation.SetLoading, true);
    const { documentId, recipientId, authId } = rootState;
    try {
      const { status, callSid } = await TwilioService.callPhone(
        documentId,
        recipientId,
        authId,
        phoneNumber
      );
      switch (status) {
        case '1':
          dispatch(ETwilioAction.CallPhoneSuccess, callSid);
          break;
        case '0':
          dispatch(
            ETwilioAction.CallPhoneFailed,
            translate('invalid-phone-entered-please-try-again')
          );
          break;
        default:
          dispatch(ETwilioAction.CallPhoneFailed);
          break;
      }
    } catch {
      dispatch(ETwilioAction.CallPhoneFailed);
    }
  },

  [ETwilioAction.CallPhoneSuccess]({ commit }, callSid) {
    commit(ETwilioMutation.SetCallSid, callSid);
    commit(ETwilioMutation.SetLoading, false);
  },

  [ETwilioAction.CallPhoneFailed]({ commit }, message?: string) {
    commit(ETwilioMutation.SetCallSid, null);
    commit(
      ETwilioMutation.SetError,
      message || translate('could-not-call-the-sender-please-contact-the-sender-manually')
    );
    commit(ETwilioMutation.SetLoading, false);
  },

  async [ETwilioAction.CancelCall]({ commit, state, rootState }) {
    const { documentId, recipientId, authId } = rootState;
    try {
      await TwilioService.cancelCall(documentId, recipientId, authId, state.callSid);
    } catch (e) {
      console.error(e);
    }
    commit(ETwilioMutation.SetCallSid, null);
    commit(ETwilioMutation.SetLoading, false);
  },
};
